import { createAsyncThunk } from "@reduxjs/toolkit";
import attendanceService from "src/services/attendance/attendance.service";

export const getAttendanceById = createAsyncThunk(
  "attendance/getAttendanceById",
  async (id: number) => {
    return attendanceService.getAttendanceById(id);
  }
);
